import React from "react";
import { Button } from "./ui/button";

export function PageButtons({
  table
})
{
  const pageCount = table.getPageCount();
  const currentPage = table.getState().pagination.pageIndex;
  const pageButtons = [];
  let startPage = 0;
  let endPage = 0;

  if (pageCount <= 4) {
    startPage = 0;
    endPage = pageCount - 1;
  } else if (currentPage <= 1) {
    startPage = 0;
    endPage = 3;
  } else if (currentPage >= pageCount - 2) {
    startPage = pageCount - 4;
    endPage = pageCount - 1;
  } else {
    startPage = currentPage - 1;
    endPage = currentPage + 2;
  }

  // Show left ellipsis if there are pages before startPage
  if (startPage > 0) {
    pageButtons.push(
      <Button
        key="left-ellipsis"
    variant="outline"
    size="sm"
    className="bg-white cursor-default pointer-events-none"
    disabled
    tabIndex={-1}
  >
  ...
    </Button>
  );
  }

  // Page buttons
  for (let i = startPage; i <= endPage && i < pageCount; i++) {
    pageButtons.push(
      <Button
        key={i}
    variant={currentPage === i ? "default" : "outline"}
    size="sm"
    className={currentPage === i ? "" : "bg-white"}
    onClick={() => table.setPageIndex(i)}
  >
    {i + 1}
    </Button>
  );
  }

  // Show right ellipsis if there are pages after endPage
  if (endPage < pageCount - 1) {
    pageButtons.push(
      <Button
        key="right-ellipsis"
    variant="outline"
    size="sm"
    className="bg-white cursor-default pointer-events-none"
    disabled
    tabIndex={-1}
  >
  ...
    </Button>
  );
  }

  return pageButtons;
}
